import React from 'react';
import { connect } from 'react-redux';
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { dateTime } from '../../utils/parsing';
import { getBrokenPoints } from '../../redux/selectors/ingestStats';
import EquipmentLoader from '../loaders/EquipmentLoader';
import PointMessage from './PointMessage';
import UnitSelector from './UnitSelector';
import PointTypeSelector from './PointTypeSelector';
import EquipSingleLink from '../explore/EquipSingle/EquipSingleLink';

import './broken-points.css';

const BuildingBrokenPoints = ({ pointsWithMessages, latestTimestamp, building }) =>
  pointsWithMessages.length === 0 ? null : (
    <>
      <EquipmentLoader buildingId={building.id} />

      <Typography variant="h6">{building.name} Broken Points</Typography>
      <Table className="broken-points">
        <TableHead>
          <TableRow>
            <TableCell>Name/Id</TableCell>
            <TableCell>Point Type</TableCell>
            <TableCell>Point Unit</TableCell>
            <TableCell>Value</TableCell>
            <TableCell>Message</TableCell>
            <TableCell>Timestamp</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {pointsWithMessages.map(([p, pm]) => (
            <TableRow key={p.id}>
              <TableCell>
                <EquipSingleLink pointId={p.id} text={`${p.name} (id=${p.id})`} />
              </TableCell>
              <TableCell>
                <PointTypeSelector selected={p.pointTypeId} disabled />
              </TableCell>
              <TableCell>
                <UnitSelector selected={p.rawUnitId} disabled />
              </TableCell>
              <TableCell>{pm.raw_value}</TableCell>
              <TableCell>
                <PointMessage message={pm.info} />
              </TableCell>
              <TableCell className={`timestamp ${pm.timestamp >= latestTimestamp ? 'latest' : ''}`}>
                {dateTime(pm.timestamp)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );

export default connect((state, { building }) => getBrokenPoints(state, building.id))(
  BuildingBrokenPoints
);
